import { GenericRequestBody, GenericResponse } from '@omnea-digital/toolbox'
import createClient from 'openapi-fetch'
import { withErrorCapture } from 'utils/general/observability/withErrorCapture'
import { ServiceUrls } from 'utils/general/serviceUrls'
import { paths } from './configGeneratedTypes'

interface Params {
  authorization: string
}

export class ConfigHttpClient {
  GET
  POST
  constructor({ authorization }: Params) {
    const { GET, POST } = createClient<paths>({
      baseUrl: ServiceUrls.CONFIG,
      headers: { Authorization: authorization },
    })
    this.GET = withErrorCapture({ method: GET })
    this.POST = withErrorCapture({ method: POST })
  }
}

export type ConfigResponse<T extends keyof paths, T2 extends keyof paths[T]> = GenericResponse<paths, T, T2>
export type ConfigRequestBody<T extends keyof paths, T2 extends keyof paths[T]> = GenericRequestBody<paths, T, T2>
